var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeEventPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "32px",
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeEventPackage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.4709201%",
    y1: "0%",
    x2: "61.5468339%",
    y2: "98.044882%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4067",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF804F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page-Pass-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-567.000000, -683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "how-it-works",
    transform: "translate(0.000000, 607.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contents",
    transform: "translate(221.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Package",
    transform: "translate(346.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2746213,23.9758298 L15.6576,31.8035064 C15.2372579,32.0452862 14.7200527,32.0452862 14.2997106,31.8035064 L0.680851064,23.9748085 C0.259324655,23.7318949 -0.000308464639,23.2822882 -1.53486584e-15,22.7957787 L-1.53486584e-15,9.86403404 C-0.000309640945,9.37759546 0.259336871,8.92806946 0.680851064,8.6852766 L4.29950638,6.60507234 C4.50971286,6.4841307 4.76847329,6.48452001 4.97831489,6.60609362 L20.0851064,15.3590468 C20.2959688,15.481517 20.4256728,15.7069945 20.4255319,15.9508426 L20.4255319,19.3937702 C20.4251662,19.5163212 20.4906999,19.6296106 20.5971166,19.690392 C20.7035333,19.7511733 20.8344069,19.7500647 20.9397787,19.6874894 L24.1774298,17.7578894 C24.384238,17.6344574 24.5108217,17.4112935 24.5106383,17.1704511 L24.5106383,13.3866213 C24.5107755,13.2646973 24.4459024,13.1519479 24.3404255,13.0907915 L9.25276596,4.34900426 C9.14720034,4.28763269 9.08232692,4.174668 9.08252342,4.05255932 C9.08271992,3.93045064 9.14795656,3.81769533 9.25371915,3.75666383 L14.2993021,0.856238298 C14.7197124,0.614531695 15.2369174,0.614531695 15.6573277,0.856238298 L29.2765957,8.68514043 C29.6982169,8.92809229 29.9578668,9.37783203 29.9574468,9.86444255 L29.9574468,22.7934638 C29.9577535,23.2813618 29.6973642,23.7322463 29.2746213,23.9758298 Z M8.17021277,19.9421277 C8.17022563,19.6984209 8.03997873,19.4732932 7.82869787,19.3518298 L3.23356596,16.7101277 C3.1281845,16.6495124 2.99847658,16.6496945 2.8932657,16.7106053 C2.78805482,16.7715161 2.72331089,16.8839101 2.72340426,17.0054809 L2.72340426,21.6118468 C2.72337738,21.8555395 2.85359642,22.0806639 3.06485106,22.2021447 L7.66011915,24.8438468 C7.76548581,24.9044212 7.89515415,24.9042269 8.00033886,24.8433371 C8.10552356,24.7824474 8.17026781,24.6700993 8.17021277,24.5485617 L8.17021277,19.9421277 Z",
    id: "HomeEventPackage"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeEventPackage);
export default __webpack_public_path__ + "static/media/HomeEventPackage.ecfd0779ac3251b59403dee2e262bf2b.svg";
export { ForwardRef as ReactComponent };